document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.querySelector('.password-toggle');
  const passwordInput = document.getElementById('customer_password');

  if (toggleBtn && passwordInput) {
    toggleBtn.addEventListener('click', function () {
      const isHidden = passwordInput.type === 'password';

      passwordInput.type = isHidden ? 'text' : 'password';
      toggleBtn.textContent = isHidden ? '👁‍🗨' : '👁';
      toggleBtn.setAttribute('aria-pressed', isHidden);
    });
  }
});